import { render, staticRenderFns } from "./ToolbarTop.vue?vue&type=template&id=584d3684&scoped=true&"
import script from "./ToolbarTop.vue?vue&type=script&lang=js&"
export * from "./ToolbarTop.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarTop.vue?vue&type=style&index=0&id=584d3684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584d3684",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/laveto/new.laveto.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('584d3684')) {
      api.createRecord('584d3684', component.options)
    } else {
      api.reload('584d3684', component.options)
    }
    module.hot.accept("./ToolbarTop.vue?vue&type=template&id=584d3684&scoped=true&", function () {
      api.rerender('584d3684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "galaxy/modules/Canvas/resources/js/editor/admin/ToolbarTop.vue"
export default component.exports